export const other_labels_fr = {
  find_your_muni: 'Trouvez votre commune',
  find_your_muni_lead:
    'Vous voulez savoir si les riches et les pauvres de votre commune sont séparés ou mélangés ? Cliquez ici pour accéder à notre outil interactif : ',
  search_muni: 'Chercher une commune',
  no_muni_selected: 'Aucune commune sélectionnée',
  neib_muni: 'Communes limitrophes',
  histo_title: 'Les couches sociales',
  histo_info:
    'Le graphique suivant montre la répartition des personnes les plus pauvres et les plus riches dans votre commune par rapport à la moyenne suisse.',
  histo_labels: [
    'Moyenne suisse',
    'Statut socio-économique',
    'Part de la population',
  ],
  poor: 'Moins aisés',
  rich: 'Plus aisés',
  poor_first: 'Moins aisés',
  rich_first: 'Plus aisés',
  sat_title: 'Les deux quartiers vus par satellite',
  chmaptitle: 'Statut socio-économique en Suisse',
  histo_text: (
    <>
      <p>
        Voici une comparaison entre votre commune et la moyenne suisse. Les
        barres divisent l'indice socio-économique SEP en 20 catégories (de 0 à
        100 points). Plus la valeur SEP est élevée, plus le statut est haut et,
        par conséquent, plus la population est riche. Dans le graphique, cela
        signifie que plus on est à droite, plus la population est aisée. Plus on
        est à gauche, plus la population est défavorisée.
      </p>
      <p>
        La hauteur des barres indique le pourcentage de personnes dans chaque
        catégorie. Plus votre commune chevauche la moyenne suisse sur la droite,
        plus elle compte de personnes aisées. Et plus votre commune chevauche la
        moyenne sur la gauche, plus votre commune compte de personnes pauvres.
      </p>
    </>
  ),

  map_labels: [
    'Communes riches au bord du lac de Zurich',
    'Zone aisée sur l’arc lémanique',
    'Population moins favorisées dans les vallées alpines',
    'Zone périphérique moins aisée dans le Jura',
  ],

  source:
    'Source: Institut de médecine sociale et préventive, Université de Berne',
}
